import React from 'react'
import {ACTIONS} from './OrderList'
import '../pages/Orders.css';
function OrderItem({ orderItem, dispatch }) {
  return (
      <tr className='table-row'>
        <td>{orderItem.style.split('_')[0]}</td>
        <td>{orderItem.company}</td>
        <td>{orderItem.color}</td>
        <td>{orderItem.USSize}</td>
        <td>{orderItem.quantity}</td>
        <td>{"$" + orderItem.price}</td>
        <td>{'%' + String(orderItem.discount)}</td>
        <td>{'$'+ orderItem.quantity * Number(orderItem.price)*(100-orderItem.discount)/100}</td>

        <td className='cancel-button-table'>
          <button onClick={() => dispatch({
              type: ACTIONS.DELETE_ORDER_ITEM,
              payload: {id: orderItem.id}})}>
                  X 
          </button> 
        </td>
      </tr>
  )
}
export default OrderItem;
